module.exports = __webpack_public_path__ + "static/media/mid-grade-large.cdf45c35.jpg";